<template>
  <v-card>
    <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
      <h2 style="color:white">Locatie bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditBranchDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert
      class="pa-1 ma-0"
      v-if="feedback"
      :value="true"
      type="warning"
      >
      {{ feedback }} 
    </v-alert>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-form ref="editBranchForm" lazy-validation>
        <v-container  grid-list-md fluid class="ma-0 pa-3">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                label="Naam"
                v-model.trim="selectedBranch.branchName"
                :rules="requiredRules"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md9>
              <v-text-field
                class="pt-2"
                label="Adres"
                v-model="selectedBranch.address"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <v-text-field
                class="pt-2"
                label="huisnummer"
                v-model="selectedBranch.number"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
                ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3>
              <v-text-field
                class="pt-2"
                label="Postcode"
                v-model="selectedBranch.postalCode"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md9>
              <v-text-field
                class="pt-2"
                label="Plaats"
                v-model="selectedBranch.city"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                class="pt-2"
                label="Provincie"
                v-model="selectedBranch.province"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                class="pt-2"
                label="Land"
                v-model="selectedBranch.country"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                class="pt-2"
                label="Telefoonnummer"
                v-model="selectedBranch.phonenumber"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                class="pt-2"
                label="E-mailadres"
                v-model="selectedBranch.email"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>

      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditCompDialog()"
              >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled=" !changed || busy" 
              :depressed="!changed || busy"  
              :dark=" changed || busy"
              :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
              rounded 
              :color="companySecondaryColor" 
              @click="updateBranch()"
              >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>


  </v-card>
</template>

<script>
import slugify from "slugify";
import db from "../../firebase/init";
import firebase from "firebase/app";
import platform from 'platform'; 

export default {
  name: "edit-branch-form",
  props: {
    selectedBranch: Object,
    selectedBranchOriginal: Object,
    activeCompData: Object
  },
  data() {
    return {
      requiredRules: [v => !!v || "Dit veld is verplicht"],
      feedback: null,
      errors: [],
      busy: false,
      panel: [0],
      surveySendTimes: [
        {
          name: "19:00u",
          value: "19"
        },
        {
          name: "21:00u",
          value: "21"
        }
      ]
    };
  },

  methods: {
    closeEditBranchDialog() {
      this.$emit("editBranchDialogChange", false);
      this.feedback = null;
    },

    updateBranch() {
      if (this.$refs.editBranchForm.validate()) {
        this.busy = true;
        let receiptBranchData = [
          "Salon",
          {
            style: "subheader",
            text: this.selectedBranch.address + " " + this.selectedBranch.number
          },
          {
            style: "subheader",
            text: this.selectedBranch.phonenumber
          },
          {
            style: "subheader",
            text: this.selectedBranch.email
          },
          {
            style: "subheader",
            text: this.activeCompData.url
          }
        ]

        db.collection("branches")
          .doc(this.selectedBranch.id)
          .set({
            branchName: this.selectedBranch.branchName,
            address: this.selectedBranch.address,
            number: this.selectedBranch.number,
            postalCode: this.selectedBranch.postalCode,
            city: this.selectedBranch.city,
            province: this.selectedBranch.province,
            country: this.selectedBranch.country,
            phonenumber: this.selectedBranch.phonenumber,
            email: this.selectedBranch.email,

          }, { merge: true })
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version, 
              action: "Locatie bewerkt: " + this.activeCompData.name,
              extra:
                "<b>ORGINELE GEGEVENS:</b><br>" +
                "<b>Naam:</b> " +
                this.selectedBranchOriginal.name +
                "<br>" +
                "<b>Straat:</b> " +
                this.selectedBranchOriginal.address +
                "<br>" +
                "<b>Huisnummer:</b> " +
                this.selectedBranchOriginal.number +
                "<br>" +
                "<b>Postcode:</b> " +
                this.selectedBranchOriginal.postalCode +
                "<br>" +
                "<b>Plaats:</b> " +
                this.selectedBranchOriginal.city +
                "<br>" +
                "<b>Provincie:</b> " +
                this.selectedBranchOriginal.province +
                "<br>" +
                "<b>Land:</b> " +
                this.selectedBranchOriginal.country +

                "<br><br>" +
                "<b>AANGEPASTE GEGEVENS:</b><br>" +
                "<b>Naam:</b> " +
                this.selectedBranch.name +
                "<br>" +
                "<b>Straat:</b> " +
                this.selectedBranch.address +
                "<br>" +
                "<b>Huisnummer:</b> " +
                this.selectedBranch.number +
                "<br>" +
                "<b>Postcode:</b> " +
                this.selectedBranch.postalCode +
                "<br>" +
                "<b>Plaats:</b> " +
                this.selectedBranch.city +
                "<br>" +
                "<b>Provincie:</b> " +
                this.selectedBranch.province +
                "<br>" +
                "<b>Land:</b> " +
                this.selectedBranch.country
            });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeEditBranchDialog();
            this.busy = false;
            console.log("Branch succesfully updated");
            this.$refs.editBranchForm.reset();
          })
          .catch(error => {
            console.error("Error updating Branch: ", error);
            this.busy = false;
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error updating Branch: " + this.activeCompName,
              extra: JSON.stringify(error)
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een locatie toe te voegen.";
      }
    }
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    changed() {
      if (_.isEqual(this.selectedBranch, this.selectedBranchOriginal) == false) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
.expansion-card{
  background-color: #f6f7fb!important;
  
}
.expansion-card .v-card__text{
  border-top: 1px solid #e8e9ee;
}
</style>
